module.exports = __webpack_public_path__ + "img/brush-02.ebf04c9a.svg";